import r2wc from '@r2wc/react-to-web-component';
import '@webcomponents/custom-elements';

import WishlistWidget from '../widgets/WishlistWidget';

const WebWishlistWidget = r2wc(WishlistWidget, {
  props: {
    thgConfig: 'json',
    configOverrides: 'json',
    mode: 'string'
  }
});

customElements.get('thg-wishlist') || customElements.define('thg-wishlist', WebWishlistWidget);
